import { useState, useEffect } from 'react'
import type { AppConfig } from '../types/config'
import { fetchConfig } from '../api/client'

interface UseConfigReturn {
  config: AppConfig | null
  loading: boolean
  error: string | null
  reload: () => Promise<void>
}

export function useConfig(): UseConfigReturn {
  const [config, setConfig] = useState<AppConfig | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const load = async () => {
    try {
      setLoading(true)
      setError(null)
      const data = await fetchConfig()
      setConfig(data)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load config')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    load()
  }, [])

  return { config, loading, error, reload: load }
}
